export default __webpack_public_path__ + "static/media/Arch_AWS-Systems-Manager_48.253109d7.svg";